import CollectionContentCardsTab from 'src/components/pages/Content/CollectionPage/CollectionContentCardsTab/CollectionContentCardsTab';

export default CollectionContentCardsTab;
